import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

/**
 * Ez egy mobil eszköz, vagy CORDOVA-val buildelünk?
 * @param ua - UserAgent.
 */
export default function isMobile (ua: string): boolean {
  return userAgentParser.isMobile(ua)
}
